/*
 * Carregamento de imagens para o canvas. Imagens de outro domínio (capa,
 * logo e fundos enviados, no S3) passam pelo proxy da API para o canvas não
 * ficar "tainted" e o download funcionar mesmo sem CORS no bucket.
 */
const cache = new Map();

function isSameOrigin(url) {
  if (url.startsWith('data:') || url.startsWith('blob:')) {
    return true;
  }

  try {
    return new URL(url, window.location.href).origin === window.location.origin;
  } catch (error) {
    return false;
  }
}

function loadElement(src, crossOrigin) {
  return new Promise(resolve => {
    const image = new Image();

    if (crossOrigin) {
      image.crossOrigin = 'anonymous';
    }

    image.onload = () => resolve(image);
    image.onerror = () => resolve(null);
    image.src = src;
  });
}

/* fetch direto em vez do axios: o interceptor do api.js redireciona para a página de 404. */
async function loadViaProxy(url) {
  const token = localStorage.getItem('auth_token');
  const endpoint = process.env.VUE_APP_API_URL + '/image-templates/proxy?url=' + encodeURIComponent(url);

  try {
    const response = await fetch(endpoint, {
      headers: token ? { Authorization: 'Bearer ' + token } : {},
    });

    if (!response.ok) {
      return null;
    }

    const blob = await response.blob();

    return loadElement(URL.createObjectURL(blob), false);
  } catch (error) {
    return null;
  }
}

async function load(url) {
  if (isSameOrigin(url)) {
    return loadElement(url, false);
  }

  const proxied = await loadViaProxy(url);

  if (proxied) {
    return proxied;
  }

  const separator = url.includes('?') ? '&' : '?';

  return loadElement(url + separator + 'v=' + Date.now(), true);
}

/* Devolve a imagem pronta para desenhar, ou null se não deu para carregar. */
export function loadImage(url) {
  if (!url) {
    return Promise.resolve(null);
  }

  if (!cache.has(url)) {
    const promise = load(url).then(image => {
      if (!image) {
        cache.delete(url);
      }

      return image;
    });

    cache.set(url, promise);
  }

  return cache.get(url);
}
